module.exports = __webpack_public_path__ + "media/categories/91-1c489491.png";